import { FC } from "react";
import { Control } from "react-hook-form";
import styled from "styled-components";

import Switch from "@/components/Switch";
import Text from "@/components/Text";
import { FormDataT } from "./InvoicesMemberModal";

const Box = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  padding: 16px;
  padding-left: 12px;
`;

const HeadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

interface Props {
  control: Control<FormDataT, any>;
  disabled: boolean;
}

const InvoicesFreelancerBlock: FC<Props> = ({ control, disabled }) => {
  return (
    <Box>
      <HeadingRow>
        <Text $type="smallBold">Freelancer account</Text>
        <Switch
          disabled={disabled}
          name="create_freelancer"
          control={control}
        />
      </HeadingRow>
      <Text $type="smallNormal" $color="gray">
        By creating an account as a freelancer, this profile will be listed in
        the freelancers' account list as a permanent freelancer.
      </Text>
    </Box>
  );
};

export default InvoicesFreelancerBlock;
